const Link = "https://refer.dunhams.brandambassador.ai";

function GetLink() {
  return Link;
}

module.exports = GetLink;
